import React from 'react';
import './css/LoadingSpinner.css';

const LoadingSpinner = () => (
    <div className="button-spinner"></div>
);

export default LoadingSpinner;
